<template>
	<div class="login-content">
		<vs-input
			v-validate="'required'"
			data-vv-validate-on="blur"
			name="username"
			icon-no-border
			icon="icon icon-user"
			icon-pack="feather"
			label-placeholder="Họ và tên"
			v-model="username"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("username") }}</span>

		<vs-input
			v-validate="'required'"
			data-vv-validate-on="blur"
			name="email"
			icon-no-border
			icon="icon icon-mail"
			icon-pack="feather"
			label-placeholder="Email"
			v-model="email"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("email") }}</span>

		<vs-input
			v-validate="'required'"
			data-vv-validate-on="blur"
			name="phone"
			icon-no-border
			icon="icon icon-phone"
			icon-pack="feather"
			label-placeholder="Điện thoại"
			v-model="phone"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("phone") }}</span>

		<vs-input
			v-validate="'required'"
			data-vv-validate-on="blur"
			name="message"
			icon-no-border
			icon="icon icon-message-circle"
			icon-pack="feather"
			label-placeholder="Lời nhắn"
			v-model="message"
			class="w-full"
		/>
		<span class="text-danger text-sm">{{ errors.first("message") }}</span>

		<div class="flex flex-wrap justify-center mb-3 mt-5">
			<vs-button :disabled="!validateForm" @click="loginJWT">Gửi đi</vs-button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			username: "",
			phone: "",
			email: "",
			message: "",
			sent: 0,
		};
	},
	computed: {
		validateForm() {
			return !this.errors.any() && this.username != "" && this.phone != "" && this.email != "" && this.message != "";
		},
	},
	methods: {
		loginJWT() {
			this.sent = 1;
			this.$vs.notify({
				title: "Thông báo",
				text: 'Chúng tôi đã nhận được và sẽ liên hệ với bạn sớm nhất có thể',
				iconPack: "feather",
				icon: "icon-alert-circle",
				color: "success",
			});
			this.username = '';
			this.phone = '';
			this.email = '';
			this.message = '';
			return;

			// Loading
			this.$vs.loading();

			const payload = {
				checkbox_remember_me: 0,
				userDetails: {
					email: this.email,
					password: 'hi',
				},
			};

			this.$store
				.dispatch("auth/loginJWT", payload)
				.then(() => {
					this.$vs.loading.close();
					this.sent = 1;
				})
				.catch((error) => {
					console.log(error.message);
					this.$vs.loading.close();
					this.sent = 1;
					// this.$vs.notify({
					// 	title: "Error",
					// 	text: error.message,
					// 	iconPack: "feather",
					// 	icon: "icon-alert-circle",
					// 	color: "danger",
					// });
				});
		},
	},
};
</script>

<style lang="scss">
.login-content input:-webkit-autofill ~ span {
	-webkit-transform: translate(-3px, -90%) !important;
	transform: translate(-3px, -90%) !important;
	padding-left: 3rem !important;
	font-size: 0.7rem !important;
	padding-top: 1rem !important;
}

// .login-content input {
// 	margin-bottom: 1rem !important;
// }
</style>
